import type { ElementType } from 'react';
import { Box, Flex, Icon, Link, Tooltip } from '@chakra-ui/react';
import { BsLinkedin, BsGithub, BsFacebook, BsTwitterX } from 'react-icons/bs';
import { Greenhouse } from '@/assets/icons/colored';
import { Lever as LeverLogo } from '@/assets/icons/colored';
import { Ashby } from '@/assets/icons/colored';

const linksConfig = {
  twitter_url: {
    id: 'TwitterX',
    label: 'TwitterX',
    icon: BsTwitterX,
    color: 'base-black',
  },
  linkedin_url: {
    id: 'Linkedin',
    label: 'Linkedin',
    icon: BsLinkedin,
    color: ' #2D64BC',
  },
  github_url: {
    id: 'Github',
    label: 'Github',
    icon: BsGithub,
    color: 'base-black',
  },
  facebook_url: {
    id: 'Facebook',
    label: 'Facebook',
    icon: BsFacebook,
    color: 'primary-500',
  },
};

type ProfileLinkProps = {
  linkedinUrl?: string;
  greenhouseUrl?: string;
  githubUrl?: string;
  leverurl?: string;
  ashbyUrl?: string;
  /** Map of provider key → URL (Object.entries); legacy typings incorrectly used any[] */
  links?: Record<string, unknown>;
  [key: string]: any;
};

export const ProfileLink = ({
  linkedinUrl,
  greenhouseUrl,
  githubUrl,
  leverurl,
  ashbyUrl,
  links = {},
  ...props
}: ProfileLinkProps) => {
  return (
    <Flex alignItems="center" alignSelf="center" {...props}>
      {Object.entries(links)?.map(([key, value]) => {
        if (!value) return null;
        const { icon, label, id, color } = linksConfig[key] || {};
        const href = typeof value === 'string' ? value : String(value);
        return (
          <Link
            key={id}
            href={href}
            target="_blank"
            _focus={{ outline: 'none' }}
          >
            <Tooltip variant="default" label={label}>
              <Box>
                <Icon
                  as={icon}
                  color={color}
                  width="16px"
                  height="16px"
                  ml="8px"
                  verticalAlign="text-top"
                />
              </Box>
            </Tooltip>
          </Link>
        );
      })}

      {linkedinUrl && (
        <Link href={linkedinUrl} target="blank" _focus={{ outline: 'none' }}>
          <Icon
            as={BsLinkedin as ElementType}
            color="#0b65c2"
            width="16px"
            height="16px"
            ml="4px"
          />
        </Link>
      )}

      {githubUrl && (
        <Link href={githubUrl} target="blank" _focus={{ outline: 'none' }}>
          <Icon
            as={BsGithub as ElementType}
            color="#000"
            width="16px"
            height="16px"
            ml="8px"
          />
        </Link>
      )}

      {greenhouseUrl && (
        <Link href={greenhouseUrl} target="blank" _focus={{ outline: 'none' }}>
          <Icon as={Greenhouse} width="16px" height="16px" ml="8px" />
        </Link>
      )}

      {leverurl && (
        <Link href={leverurl} target="blank" _focus={{ outline: 'none' }}>
          <Icon as={LeverLogo} width="16px" height="16px" ml="8px" />
        </Link>
      )}

      {ashbyUrl && (
        <Link href={ashbyUrl} target="blank" _focus={{ outline: 'none' }}>
          <Icon as={Ashby} width="16px" height="16px" ml="8px" />
        </Link>
      )}
    </Flex>
  );
};
